module.exports = __webpack_public_path__ + "img/login-background.70996a9b.png";